import { cn } from "@/lib/utils";

interface UnreadBadgeProps {
  count: number;
  /** Ekstra klasser, f.eks. for å overstyre posisjonering. */
  className?: string;
}

/**
 * VIB-2179: liten rød teller-badge for uleste elementer, plassert øverst til
 * høyre på en `relative` forelder. Samme visuelle språk som varselbjella
 * (NotificationBell). Rendrer ingenting ved 0.
 */
export function UnreadBadge({ count, className }: UnreadBadgeProps) {
  if (count <= 0) return null;
  return (
    <span
      aria-label={`${count} uleste`}
      className={cn(
        "absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-1 bg-destructive text-destructive-foreground text-[10px] rounded-full flex items-center justify-center font-medium tabular-nums pointer-events-none",
        className,
      )}
    >
      {count > 99 ? "99+" : count}
    </span>
  );
}

export default UnreadBadge;
